function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1.08.358h15.84a1 1 0 01.78 1.625l-6.48 8.1a1 1 0 00-.22.626v5.149a1 1 0 01-.4.8l-2 1.5a1 1 0 01-1.6-.8v-6.65a1 1 0 00-.22-.624L.3 1.983A1 1 0 011.08.358z",
  fill: "#000"
}));